import translator from '@Components/Utilities/Translator';
import { setCookie } from '@Components/Utilities/CookieHelper';
import { useState } from 'react';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import { daysToSnoozeCurrencyAlerts } from '@Components/Utilities/SandhillsConstants';

const CurrencyAlertPopUp = (props) => {
    const [isSnoozed, setIsSnoozed] = useState(false);
    const routes = useRecoilValue(atoms.routes);

    const snoozeCurrencyPopUp = () => {
        const expiration = new Date();
        expiration.setDate(expiration.getDate() + daysToSnoozeCurrencyAlerts);
        setCookie('CurrencyAlertsSnoozed', 'true', expiration);

        setIsSnoozed(true);
    };

    return (
        <div className={`currency-pop-up-container ${!isSnoozed ? "not-snoozed" : ""}`} id="CurrencyAlertContainer">
            <div className="checkmark">
                <svg xmlns="http://www.w3.org/2000/svg" height="60" width="60" viewBox="0 0 60 60" aria-hidden="true">
                    <circle className="checkmark-circle" cx="30" cy="30" r="30" />
                    <path className="checkmark-check" fill="none" stroke="#FFF" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" d="M14 27l5.917 4.917L34 17" />
                </svg>
            </div>
            <div className="confirmation-text">
                <span dangerouslySetInnerHTML={{ __html: props.confirmationTextHeader }}></span>
                <span dangerouslySetInnerHTML={{ __html: props.confirmationTextBody }}></span>
            </div>
            {!isSnoozed &&
                <>
                    <div className="confirmation-widgets">
                        <div className="cta-button fadeinbottom">
                            <div className="animated-border-box-glow" />
                            <div className="animated-border-box" />
                        <a className="cta-block-btn" href={props.applyForFinancingURL} id="gtm-currency-popup" target="_blank" aria-label={translator.translate('sandhills.tradesites.mvc.applyforfinancing') + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>{translator.translate('sandhills.tradesites.mvc.applyforfinancing')}</a>
                            <div className="cta-button-bg" />
                        </div>
                        <div className="currency-logo fadeinbottom">
                            <img src={routes.CDNBaseUrl + 'Images/Logos/ThirdParty/currency-logo-medium-white.png'} alt={translator.translate('sandhills.currency')} />
                        </div>
                        <div className="snooze-btn fadeinbottom">
                        <a role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); snoozeCurrencyPopUp(); }}} onClick={snoozeCurrencyPopUp}>{translator.translate('sandhills.snoozealertsfromcurrency', [daysToSnoozeCurrencyAlerts])}</a>
                        </div>
                    </div>
                    <div className="background">
                        {/*Background animation is styled from CSS using these spans*/}
                        {Array.from({ length: 20 }, (_, i) => <span key={i} />)}
                    </div>
                </>}
        </div>
    );
};

export default CurrencyAlertPopUp;